import onClickOutside from "click-outside-js";

const menuItems = document.querySelectorAll('.navbar__menu__item');
const types = ['uslugi', 'catalog', 'company'];

const all = (arr, fn = Boolean) => arr.every(fn);

const toggleMenuBg = () => {
    const bg = document.querySelector('.navbarMenu');
    const els = types.map(type => {
        const menuList = document.querySelector(`.navbarMenu__list--${type}`);
        return menuList.classList.contains('hidden')
    });

    if (all(els, x => x === true)) {
        bg && bg.classList.add('hidden')
    } else {
        bg && bg.classList.remove('hidden')
    }
}

const closeOtherTypes = (type) => {
    const otherMenuTypes = types.filter(el => el !== type);
    otherMenuTypes.map(menuType => {
        const className = `.navbarMenu__list--${menuType}`;
        const el = document.querySelector(className);
        el.classList.add('hidden');

        const otherMenuItem = document.querySelector(`[data-menu="${menuType}"]`);
        const arrow = otherMenuItem.querySelector('.navbar__menu__item__arrow');
        arrow.classList.remove('navbar__menu__item__arrow--open')
    })
}

const showMenuByType = (type) => {
    const className = `.navbarMenu__list--${type}`;
    const el = document.querySelector(className);
    el.classList.toggle('hidden');
}

[...menuItems].map(menuItem => {
    menuItem.addEventListener('click', (e) => {
        if(e.target.classList.contains('navbar-Menu__item') || e.target.classList.contains('navbarMenu__list')) {
            return;
        }
        
        const type = e.currentTarget.getAttribute('data-menu');
        const arrow = e.currentTarget.querySelector('.navbar__menu__item__arrow');
        arrow.classList.toggle('navbar__menu__item__arrow--open')
        closeOtherTypes(type);
        showMenuByType(type);
        toggleMenuBg();
    })
});

const closeMenu = () => {
    const menu = document.querySelector('.navbarMenu');
    menu && menu.classList.add('hidden');
    
    const arrows = document.querySelectorAll('.navbar__menu__item__arrow');
    arrows.forEach(arrow => {
        arrow.classList.remove('navbar__menu__item__arrow--open');
    });
    
    const lists = document.querySelectorAll('.navbarMenu__list');
    lists.forEach(list => {
        list.classList.add('hidden');
    })
}

const navbar = document.querySelector('.navbar');
navbar && new onClickOutside(navbar, function() {
    closeMenu();
});
